import { forwardRef, useId, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/ui";

type TextFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
  hint?: string;
};

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ className, label, error, hint, id, ...props }, ref) => {
    const generatedId = useId();
    const inputId = id ?? generatedId;
    const descriptionId = error || hint ? `${inputId}-description` : undefined;

    return (
      <div className="field">
        {label ? <label className="field__label" htmlFor={inputId}>{label}</label> : null}
        <input
          ref={ref}
          id={inputId}
          inputMode={props.type === "number" ? "decimal" : props.inputMode}
          className={cn("field__input", error && "field__input--error", className)}
          aria-invalid={Boolean(error)}
          aria-describedby={descriptionId}
          {...props}
        />
        {error || hint ? (
          <span id={descriptionId} className={cn("field__message", error && "field__message--error")}>
            {error ?? hint}
          </span>
        ) : null}
      </div>
    );
  }
);

TextField.displayName = "TextField";
